import { render, staticRenderFns } from "./CustomerAddressCreate.vue?vue&type=template&id=43045ca4&"
import script from "./CustomerAddressCreate.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports